var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailSent = function SvgEmailSent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 76
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD829",
    d: "M89.933 70.05c0 3.198-2.031 5.789-4.535 5.789H4.535C2.03 75.839 0 73.249 0 70.05V19.882c0-3.196 2.03-5.788 4.535-5.788h80.863c2.504 0 4.535 2.592 4.535 5.788z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1BF33",
    d: "m50.355 48.759 35.744 27.08c2.17-.425 3.834-2.821 3.834-5.722V19.89c0-3.2-2.024-5.795-4.52-5.795h-.435L50.269 41.348c-2.629 2.066-2.59 5.383.086 7.41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1BF33",
    d: "M4.243 75.839h80.948c.741 0 1.439-.23 2.057-.628L47.514 38.32c-2.048-1.902-5.339-1.874-7.35.062L2.014 75.095c.659.472 1.418.744 2.23.744"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD829",
    d: "M89.933 70.05V19.882c0-3.197-2.039-5.788-4.554-5.788H65.676a3.91 3.91 0 0 0-2.726 3.73 3.906 3.906 0 0 0 3.9 3.913h11.472a3.23 3.23 0 0 1 3.224 3.235 3.23 3.23 0 0 1-3.224 3.236h-.675a3.906 3.906 0 0 0-3.9 3.912 3.907 3.907 0 0 0 3.9 3.912h.675a3.23 3.23 0 0 1 3.224 3.235 3.23 3.23 0 0 1-3.224 3.235H64.15a3.906 3.906 0 0 0-3.899 3.912 3.906 3.906 0 0 0 3.9 3.913h14.171a3.23 3.23 0 0 1 3.224 3.235 3.23 3.23 0 0 1-3.224 3.235h-26.77a3.905 3.905 0 0 0-3.898 3.912 3.905 3.905 0 0 0 3.899 3.912h26.77a3.23 3.23 0 0 1 3.223 3.236 3.23 3.23 0 0 1-3.224 3.235H37.456a3.906 3.906 0 0 0-3.808 4.747h51.73c2.516 0 4.555-2.591 4.555-5.789"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.28,
    d: "M86.225 14.765H4.095c-1.036 0-1.983.474-2.753 1.246l41.122 46.025c2.078 2.326 5.418 2.291 7.46-.076l39.338-45.636c-.812-.96-1.867-1.559-3.037-1.559"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE56A",
    d: "M84.929 14.094H4.052c-1.021 0-1.951.397-2.71 1.042l40.493 38.459c2.048 1.943 5.336 1.914 7.346-.064l38.738-38.134c-.799-.801-1.839-1.303-2.99-1.303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.5,
    d: "M47.59 48.693c-1.03 1.232-2.76 1.302-3.867.155L23.69 28.098c-1.106-1.148-1.168-3.075-.14-4.308 1.03-1.231 2.762-1.302 3.867-.155L47.45 44.387c1.107 1.146 1.17 3.074.14 4.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E73026",
    d: "M99.672 14.764c0 8.06-6.534 14.595-14.594 14.595s-14.595-6.534-14.595-14.595S77.017.17 85.078.17s14.594 6.534 14.594 14.594"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M84.588 20.349v-9.527h-.049l-3.006 2.075v-2.222l3.047-2.117h2.452v11.79z"
  }))));
};
export { SvgEmailSent as ReactComponent };
export default __webpack_public_path__ + "c6b625b015d6afae7b0500318f88b7b1.svg";